import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=7bc3f358&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/authenticate/_forgot-password.scss?vue&type=style&index=0&id=7bc3f358&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc3f358",
  null
  
)

export default component.exports